/**
 * Created by seaasun on 2018/2/7.
 */
import datasource from './datasource'
import geoType from './geoType'
import demoType from './demoType'
import link from './link'
import suppressionTypeMap from './suppressionTypeMap'
import order from './order'
import dev from './dev'

export default {
  datasource,
  geoType,
  demoType,
  link,
  suppressionTypeMap,
  order,
  dev
}



// WEBPACK FOOTER //
// ./src/config/index.js